import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IPrepaidProgramDataTableRowFormMeta {
  // idTable: FormInputMeta,
  // nameTable: FormInputMeta,
  miscellaneousPeriodicCostsTable: FormInputMeta,
  schema: any,
}

const PrepaidProgramDataTableRowFormMeta = {} as IPrepaidProgramDataTableRowFormMeta;

 
PrepaidProgramDataTableRowFormMeta.miscellaneousPeriodicCostsTable = {
  name: "miscellaneousPeriodicCostsTable",
  label: "Frais periodiques divers",
  type: "select",
  options:  [
    {
      label: 'NameA',
      value: 'IDA'
    },
    {
      label: 'NameB',
      value: 'IDB',
    },
    {
      label: 'NameC',
      value: 'IDC',
    },
  ],
  validation: yup.string().required("Ce champ est requis"),
}
// PrepaidProgramDataTableRowFormMeta.idTable = {
//   name: "idTable",
//   label: "ID",
//   type: "text",
//   validation: yup.string().required(),
// }

PrepaidProgramDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(PrepaidProgramDataTableRowFormMeta));

export default PrepaidProgramDataTableRowFormMeta;
